import * as React from "react";
import { forwardRef } from "react";
const SvgPageFirst = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.6663 10.0402L8.69374 8.00016L10.6663 5.96016L10.0604 5.3335L7.48181 8.00016L10.0604 10.6668L10.6663 10.0402ZM5.33301 5.3335H6.19253V10.6668H5.33301V5.3335Z", fill: "#898E97" }));
const ForwardRef = forwardRef(SvgPageFirst);
export { ForwardRef as ReactComponent };
